
import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Event, Router, NavigationStart, NavigationEnd, RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PageLoaderComponent } from './layout/page-loader/page-loader.component';
import { BrandingService } from '@core/service/branding.service';
import { AuthService } from '@core/service/auth.service';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterModule, PageLoaderComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  currentUrl!: string;
  constructor(public _router: Router, private _title: Title, private _translate: TranslateService, private _branding: BrandingService, private _auth: AuthService) {
    // Refresh user from Keycloak token NOW (after APP_INITIALIZERs complete)
    // This ensures the correct role is set before any child component subscribes
    this._auth.refreshFromKeycloak();
    this._branding.init();
    this._router.events.subscribe((routerEvent: Event) => {
      if (routerEvent instanceof NavigationStart) {
        this.currentUrl = routerEvent.url.substring(
          routerEvent.url.lastIndexOf('/') + 1
        );
      }
      if (routerEvent instanceof NavigationEnd) {
        /* empty */
      }
      window.scrollTo(0, 0);
    });

    this._translate.onLangChange.subscribe(() => {
      this._title.setTitle('Assetvio - ' + this._translate.instant('ABOUT.PLATFORM_NAME'));
    });
  }
}
